import React, { useEffect } from "react";
import { Box } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";

import DevelopmentNeedTable from "../../PORT/DevelopmentNeed/DevelopmentNeedTable";
import FormBuilder from "../../../Common/FormBuilder/FormBuilder";

import { getPDPDetails } from "../../../../actions/rmsActions";
import { getPDP } from "../../../../reducers";

function DevelopmentNeedContent({
    segment,
    appraisalId,
    onFormFieldChange,
    canAdd = false,
    isAppraiser = false,
    appraiseeUUID = null,
    appCode,
}) {
    const dispatch = useDispatch();

    const pdpId = !!segment?.items.length ? segment.items[0].pdpId : null;
    const pdp = useSelector((state) => getPDP(state, Number(pdpId)));

    useEffect(() => {
        if (isAppraiser && !!pdpId && !pdp) {
            dispatch(getPDPDetails(pdpId, appCode));
        }
    }, [dispatch, pdp, isAppraiser, pdpId, appCode]);

    const canUpdate = !!segment?.canUpdate;
    let canComplete = false;

    if (isAppraiser && !!pdp && pdp.status === "open") {
        if (segment.items?.length > 0) {
            canComplete = segment.items.every((item) =>
                ["completed", "deferred", "cancelled"].includes(item.status)
            );
        } else {
            canComplete = true;
        }
    }

    return (
        <>
            <Box className="card-content">
                <DevelopmentNeedTable
                    canUpdate={canUpdate}
                    canAdd={canAdd}
                    canComplete={canComplete}
                    isAppraiser={isAppraiser}
                    appraiseeUUID={appraiseeUUID}
                    items={segment?.items ?? []}
                    appraisalId={appraisalId}
                    pdpId={pdpId}
                    embedded={true}
                    appCode={appCode}
                />
            </Box>
            <FormBuilder
                form={segment?.form ?? []}
                canUpdate={canUpdate}
                onFieldChange={onFormFieldChange}
            />
        </>
    );
}

export default DevelopmentNeedContent;
